import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
 const state={   //要设置的全局访问的state对象
     userName:window.localStorage.getItem('name') || '',	  
     userRole:window.localStorage.getItem('role') || '',
	 dataUrl:'liantongp.yoooooo.com',//data2.yoooooo.com,localhost
     //要设置的初始属性值
   };
const getters = {   //实时监听state值的变化(最新状态)
    getName(state) {  //承载变化的showFooter的值
       return state.userName
    },
    getRole(state){  //承载变化的changebleNum的值
       return state.userRole
    },
	getUrl(state){
		return state.dataUrl
	}
};
const mutations = {
     
    setName(state) {  //同上
        state.userName = window.localStorage.getItem('name');		 
    },
    setRole(state){ //同上，这里面的参数除了state之外还传了需要增加的值sum
       state.userRole = window.localStorage.getItem('role');
    }
};
 const actions = {
    disName(context) {  //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
        context.commit('setName');
    },
    disRole(context,role) {  //同上注释
        context.commit('setRole');
    },
    
};
 const store = new Vuex.Store({
       state,
       getters,
       mutations,
	   actions
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js